import { NOT_FOUND } from 'redux-first-router';
import axios from 'axios';
import * as actions from 'actions';
import { canUseDOM } from 'helpers';

const getHost = (apiPaths) => {
  if (canUseDOM) {
    return apiPaths.client;
  } else if (apiPaths.server) {
    return apiPaths.server;
  }
  return 'http://dev.great.ru/preview';
};

const fetchData = async (dispatch, getState) => {
  const { apiPaths } = getState();
  const host = getHost(apiPaths);

  // const host = 'http://dev.great.ru/preview';
  try {
    const { data: cachedData } = getState();

    if (cachedData) return;
    const { data } = await axios.get(host);

    dispatch({
      type: actions.DATA_FETCHED,

      payload: { ...data.db },
    });
  } catch (e) {
    console.log(e);
  }
};

const fetchWorks = async (dispatch, getState) => {
  const { apiPaths } = getState();
  const host = getHost(apiPaths);

  // const host = 'http://dev.great.ru/preview';

  try {
    const { data: cachedData } = getState();

    if (cachedData) return;
    const { data } = await axios.get(host);

    dispatch({
      type: actions.DATA_FETCHED,

      payload: { ...data.db },
    });
    const state = getState();

    const { caseItem } = state.location.payload;
    const { cases } = state.data;

    const caseAbscent = !cases[caseItem];

    if (caseAbscent) {
      dispatch({ type: [NOT_FOUND] });
    }
  } catch (e) {
    console.log(e);
  }
};

export default {
  HOME: {
    path: '/',
    thunk: fetchData,
  },

  WORKS: {
    path: '/works/:caseItem',
    thunk: fetchWorks,
  },
  AGENCY: {
    path: '/agency/:anchor(.*)?',
    thunk: fetchData,
  },
  REELS: {
    path: '/reels',
    thunk: fetchData,
  },
  [NOT_FOUND]: { thunk: fetchData },
};



// WEBPACK FOOTER //
// ./src/routesMap.js